export { areEquivalent };

const areEquivalent = (a: unknown, b: unknown): boolean => {
	const aNormalized = normalize(a);
	const bNormalized = normalize(b);

	if (aNormalized === null) {
		return bNormalized === null;
	}

	if (bNormalized === null) {
		return false;
	}

	if (typeof aNormalized !== typeof bNormalized) {
		return false;
	}

	if (typeof aNormalized === 'object' || Array.isArray(aNormalized)) {
		return JSON.stringify(aNormalized) === JSON.stringify(bNormalized);
	}

	return aNormalized === bNormalized;
};

const normalize = (value: unknown): unknown => {
	if (value === null || value === undefined) {
		return null;
	}

	if (Array.isArray(value)) {
		if (value.length === 1) {
			return normalize(value[0]);
		}

		return value.map((v) => normalize(v));
	}

	if (typeof value === 'object') {
		const normalized = {};
		for (const key of Object.keys(value).sort()) {
			normalized[key] = normalize(value[key]);
		}

		return normalized;
	}

	if (typeof value === 'string') {
		return Number.isNaN(+value) ? value.trim() : +value;
	}

	return value;
};
